import * as React from "react";
import { forwardRef } from "react";
const SvgOldStop = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-labelledby={titleId} fill="currentColor" ref={ref} {...props}>{title === undefined ? <title id={titleId || "title"}>{"Stop"}</title> : title ? <title id={titleId || "title"}>{title}</title> : null}<path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z" /></svg>;
const ForwardRef = forwardRef(SvgOldStop);
export { ForwardRef as ReactComponent };